module.exports = __webpack_public_path__ + "static/media/app-store.262e746f.svg";